import React from 'react';
import store from '../../../Store';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {toggleMigrationTrackingListFilter} from './MigrationTracking-Action'
import {unslufigy} from "../../../helpers/StringHelper";
import {Link} from "react-router-dom";
import Button from "../../../components/shared/buttons/Button";

class MigrationTrackingListFilters extends React.Component {

    toggleFilter = (e) => {
        store.dispatch(toggleMigrationTrackingListFilter(e, this.props.history));
    }

    render() {
        let {title, params} = this.props;

        return (
            <div className="heading-block pr-60">
                <div className="title-block">
                    <h2>{unslufigy(title)}</h2>
                </div>
               {/* <div className="search-bar">
                    <input type="text"
                           className="form-control"
                           name="q"
                           placeholder={`Search ${unslufigy(title)}`}
                           value={params.q}
                           onChange={this.toggleFilter}
                    />
                    <span className="icon-search"/>
                </div>
                <div className="button-wrapper">
                    <Link to={`/${title}/create`}>
                        <Button className="btn-theme btn-dark-blue"
                                title={`Add ${unslufigy(title)}`}
                                text={`Add ${unslufigy(title)}`}/>
                    </Link>
                </div>*/}
            </div>

        )
    }
}

function mapStateToProps(state) {
    let {getsMigrationTracking, migrationTrackingList} = state;
    let {success} = getsMigrationTracking;

    let list =
        success &&
        success.data &&
        success.data.data &&
        success.data.data.data;


    let {params} = migrationTrackingList.data;


    return {list, getsMigrationTracking, params};
}

export default withRouter(connect(mapStateToProps)(MigrationTrackingListFilters));